
export const UPDATE_USER = 'UPDATE_USER'
export const LOG_OUT = 'LOG_OUT'
export const HANDLE_AUTH_UPDATE = 'HANDLE_AUTH_UPDATE'


export const TOGGLE_LAYER = 'TOGGLE_LAYER'
export const SHOW_DATA = 'SHOW_DATA'
export const TOGGLE_DATA_WINDOW = 'TOGGLE_DATA_WINDOW'
export const SET_DATA = 'SET_DATA'
export const SET_POPULATION = 'SET_POPULATION'
export const SET_SITE = 'SET_SITE'
export const SET_TAB = 'SET_TAB'
export const SET_LAYERS = 'SET_LAYERS'
export const CREATE_WEBSOCKETS_CONNECTION = 'CREATE_WEBSOCKETS_CONNECTION'
export const FETCH_LAYERS = 'FETCH_LAYERS'
